<script setup lang="ts">
  import { IconChevronRight } from '@gat-ship/icons'

  defineProps<{
    disabled?: boolean
  }>()

  defineEmits<{
    (e: 'click'): void
  }>()

  defineSlots<{
    default: () => unknown
    chevron?: () => unknown
  }>()
</script>

<template>
  <button
    type="button"
    :disabled="disabled"
    class="bg-background shadow-xs ring-border hover:bg-accent/40 relative flex w-full cursor-pointer items-center gap-3.5 rounded-sm p-4 text-left ring-1 ring-inset transition disabled:cursor-not-allowed disabled:opacity-60"
    @click="$emit('click')"
  >
    <slot />
    <div class="ml-auto">
      <slot name="chevron">
        <IconChevronRight class="text-muted-foreground size-4" />
      </slot>
    </div>
  </button>
</template>
